const mediaVideo = {
    init: function ($videoComponents) {
        if (!$videoComponents) {
            return;
        }

        Array.from($videoComponents).forEach($videoWrapper => {
            const $btn = $videoWrapper.querySelector('button');

            if (!$btn || !$videoWrapper.dataset.videoid || !$videoWrapper.dataset.videoPlayerId) {
                return;
            }

            $btn.addEventListener('click', () => {
                this.getYT().then(YT =>
                    this.addVideo(YT.Player, $videoWrapper.dataset.videoPlayerId, $videoWrapper.dataset.videoid)
                );
            });
        });
    },
    getYT: function () {
        return new Promise(res => {
            if (window.YT) {
                res(window.YT);
                return;
            }

            window.onYouTubeIframeAPIReady = function () {
                if (window.YT) {
                    res(window.YT);
                    return;
                }
            };

            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    },
    addVideo: function (Player, playerID, videoID) {
        new Player(playerID, {
            width: '100%',
            videoId: videoID,
            playerVars: {autoplay: 1, playsinline: 1, modestbranding: 1},
            events: {
                onReady: event => event.target.playVideo()
            }
        });
    }
};

export default mediaVideo;
